// extracted by mini-css-extract-plugin
export var additionalLink = "submenu-module--additionalLink--13bbd";
export var additionalLinkContainer = "submenu-module--additionalLinkContainer--67a64";
export var additionalLinkLabel = "submenu-module--additionalLinkLabel--e99fd";
export var contentContainer = "submenu-module--contentContainer--2d6fc";
export var fadeIn = "submenu-module--fadeIn--efb70";
export var inner = "submenu-module--inner--fbd47";
export var menuItem = "submenu-module--menuItem--e2d27";
export var menuSection = "submenu-module--menuSection--ce1e0";
export var noticeBarVisible = "submenu-module--noticeBarVisible--5457d";
export var reveal = "submenu-module--reveal--9c11c";
export var settleIn = "submenu-module--settleIn--10954";
export var submenu = "submenu-module--submenu--0a836";